import React from "react";
import PropTypes from "prop-types";
import Button from "@material-ui/core/Button";

export const WarningButton = (props) => {
	const { label, handleOnClick, style, active, buttonIcon } = props;

	return (
		<Button
			variant="contained"
			style={{
				padding: "8px 34px",
				borderRadius: 40,
				backgroundColor: active ? "#ffce00" : "#eeeeee",
				borderColor: "#ffce00",
				color: "black",
				fill: "black",
				textAlign: "center",
				whiteSpace: "nowrap",
				...style,
			}}
			onClick={() => {
				if (handleOnClick && !!active) {
					handleOnClick();
				}
			}}
			startIcon={buttonIcon}
		>
			{label}
		</Button>
	);
};

WarningButton.propTypes = {
	label: PropTypes.string,
	handleOnClick: PropTypes.func,
	style: PropTypes.object,
	active: PropTypes.bool,
	buttonIcon: PropTypes.object,
};

WarningButton.defaultProps = {
	active: true,
};
